import { IAnsweredQuery } from "process/tailoring/models/answered-query.interface";

export class AnsweredQuery implements IAnsweredQuery {
	constructor(public queryId: string, public answerId: string) {}
}
